import {
  INIT_POST,
  INIT_MY_POST,
  SET_SELECTED_POST,
  CREATE_POST,
  DELETE_POST,
  UPDATE_POST,
  CREATE_COMMENT,
  DELETE_COMMENT,
  CHANGE_USERNAME,
  DELETE_LIKE,
  CREATE_LIKE,
} from './types';

const formatPost = (post) => ({
  id: post._id,
  ...post,
});

const reducer = (state, action) => {
  const { type, payload } = action;

  switch (type) {
    case INIT_POST: {
      const posts = payload.map(formatPost);
      return {
        ...state,
        posts: [...state.posts, ...posts],
      };
    }
    case INIT_MY_POST: {
      const myPosts = payload.map(formatPost);
      return {
        ...state,
        myPosts,
      };
    }
    case SET_SELECTED_POST: {
      const { post } = payload;

      return {
        ...state,
        selectedPostId: post.id || post._id,
        selectedPost: post,
      };
    }
    case CREATE_POST: {
      return {
        ...state,
        posts: [formatPost(payload.createdPost), ...state.posts],
      };
    }
    case UPDATE_POST: {
      const { posts, selectedPostId } = state;
      const { updatedPost } = payload;
      const nextPosts = [...posts];
      const index = nextPosts.findIndex(({ id }) => id === selectedPostId);
      if (index === -1) {
        nextPosts[index] = formatPost(updatedPost);

        return {
          ...state,
          posts: nextPosts,
          selectedPost: nextPosts[index],
        };
      }

      return {
        ...state,
        selectedPost: formatPost(updatedPost),
      };
    }
    case DELETE_POST: {
      const { selectedPostId, posts } = state;
      const nextPosts = [...posts].filter(({ id }) => id !== selectedPostId);

      return {
        ...state,
        posts: nextPosts,
      };
    }
    case CREATE_COMMENT: {
      const { posts, selectedPostId } = state;
      const { createdComment } = payload;
      const nextPosts = [...posts];
      const index = nextPosts.findIndex(({ id }) => id === selectedPostId);
      if (index !== -1) {
        nextPosts[index].comments = [
          ...nextPosts[index].comments,
          createdComment,
        ];

        return {
          ...state,
          posts: nextPosts,
          selectedPost: nextPosts[index],
        };
      }

      return {
        ...state,
        selectedPost: {
          ...state.selectedPost,
          comments: [...state.selectedPost.comments, createdComment],
        },
      };
    }
    case DELETE_COMMENT: {
      const { posts, selectedPostId } = state;
      const { commentId } = payload;
      const nextPosts = [...posts];
      const index = nextPosts.findIndex(({ id }) => id === selectedPostId);
      if (index !== -1) {
        nextPosts[index].comments = nextPosts[index].comments.filter(
          ({ _id }) => commentId !== _id,
        );

        return {
          ...state,
          selectedPost: nextPosts[index],
        };
      }

      return {
        ...state,
        selectedPost: {
          ...state.selectedPost,
          comments: state.selectedPost.comments.filter(
            ({ _id }) => _id !== commentId,
          ),
        },
      };
    }
    case DELETE_LIKE: {
      const { posts } = state;
      const { userId, postId } = payload;

      const nextPosts = [...posts];
      const index = nextPosts.findIndex(({ id }) => id === postId);
      const updatePost = {
        ...nextPosts[index],
        likes: nextPosts[index].likes.filter(({ user }) => user !== userId),
      };

      nextPosts[index] = updatePost;

      return {
        ...state,
        posts: nextPosts,
      };
    }
    case CREATE_LIKE: {
      const { posts } = state;
      const { createdLike, postId } = payload;

      const nextPosts = [...posts];
      const index = nextPosts.findIndex(({ id }) => id === postId);
      const updatePost = {
        ...nextPosts[index],
        likes: [...nextPosts[index].likes, createdLike],
      };

      nextPosts[index] = updatePost;

      return {
        ...state,
        posts: nextPosts,
      };
    }
    case CHANGE_USERNAME: {
      const { posts } = state;
      const { userId, username } = payload;
      const nextPosts = [...posts].map((post) =>
        post.author._id === userId
          ? { ...post, author: { ...post.author, username } }
          : post,
      );

      return {
        ...state,
        posts: nextPosts,
      };
    }
    default: {
      console.error('잘못된 타입입니다!');
    }
  }
};

export default reducer;
